var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard2Back(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.95 155.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{letter-spacing:.01em;}.cls-3{letter-spacing:0em;}.cls-4{fill:#2b374c;font-size:9px;}.cls-4,.cls-5{font-family:CFArmadilloStd-Medium, 'CF Armadillo Std';font-weight:500;}.cls-6{opacity:.6;}.cls-7{clip-path:url(#clippath-2);}.cls-8{fill:#373535;}.cls-9{letter-spacing:0em;}.cls-10{clip-path:url(#clippath-1);}.cls-11{clip-path:url(#clippath-4);}.cls-12{letter-spacing:-.06em;}.cls-13{fill:#c9e6cd;}.cls-5{fill:#90d0b9;font-size:11px;}.cls-14{clip-path:url(#clippath);}.cls-15{fill:none;}.cls-16{clip-path:url(#clippath-3);}.cls-17{letter-spacing:.01em;}.cls-18{letter-spacing:-.03em;}.cls-19{clip-path:url(#clippath-5);}.cls-20{letter-spacing:0em;}.cls-21{letter-spacing:0em;}.cls-22{letter-spacing:0em;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 182.93,
    y: 46.24,
    width: 39.7,
    height: 22.68
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m224.44,155.91H16.5C7.39,155.91,0,148.52,0,139.41V16.5C0,7.39,7.39,0,16.5,0h207.95c9.11,0,16.5,7.39,16.5,16.5v122.91c0,9.11-7.39,16.5-16.5,16.5"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-5",
    transform: "translate(14.63 114.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 0,
    y: 0
  }, "ww"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 14.32,
    y: 0
  }, "w.cap"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 41.11,
    y: 0
  }, "i"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 45.04,
    y: 0
  }, "o.com /card"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 101.63,
    y: 0
  }, "s")), /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m224.13,155.91H16.82c-9.29,0-16.82-7.53-16.82-16.82v-21.94h240.95v21.94c0,9.29-7.53,16.82-16.82,16.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.63,
    y: 46.24,
    width: 121.89,
    height: 22.68
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(14.85 41.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 0
  }, "Exp."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 16.7,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 19.3,
    y: 0
  }, "Date: 0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 48.34,
    y: 0
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 53.85,
    y: 0
  }, "/"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 57.28,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    x: 62.44,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(99.33 41.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 0
  }, "CV"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 10.07,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 15.23,
    y: 0
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 17.39,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 19.99,
    y: 0
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 24.9,
    y: 0
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.28,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m217.41,68.92h-29.25c-2.89,0-5.22-2.34-5.22-5.22v-12.23c0-2.89,2.34-5.22,5.22-5.22h29.25c2.89,0,5.22,2.34,5.22,5.22v12.23c0,2.89-2.34,5.22-5.22,5.22"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard2Back);
export default __webpack_public_path__ + "static/media/bank-card-2-back.a05ae9d0c5ff7dc57b37b097a1061a36.svg";
export { ForwardRef as ReactComponent };